import { Box, CircularProgress } from '@material-ui/core';
import { CheckBox, DocumentFileIcon } from '@room-match/shared-ui-components';
import { useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { goToLink } from 'shared/utils/goToLink';
import { DocumentContainer, DocumentIconContainer, DocumentName } from './Document.styles';

type DocumentItemProps = {
  document: IMedia;
  handleCheck: VoidFunction;
  isAllowed?: boolean;
};

export const DocumentHiddenItem = ({ document, handleCheck, isAllowed }: DocumentItemProps) => {
  const attachment =
    document?.attributes?.attachment_url ||
    document?.attributes?.attachment ||
    document?.attributes?.cropped_attachment_url ||
    document?.attributes?.modified_attachment_url;
  const [clicked, setClicked] = useState(false);

  const handleChange = () => {
    if (isAllowed) {
      setClicked((prev) => !prev);
    }
    handleCheck();
  };
  return (
    <DocumentContainer onClick={() => goToLink(attachment)}>
      <DocumentIconContainer>
        <DocumentFileIcon />
      </DocumentIconContainer>
      <DocumentName>{document?.attributes?.file_name}</DocumentName>
      <Box style={{ textAlign: 'end' }}>
        {clicked ? (
          <CircularProgress style={{ marginLeft: 4 }} size={20} />
        ) : (
          <CheckBox
            checked={!isAllowed ? false : undefined}
            style={{ opacity: isAllowed ? 1 : 0.6, padding: 0 }}
            onChange={handleChange}
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </Box>
    </DocumentContainer>
  );
};
